var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid, useTheme } from '@mui/material';
import { useOrderListItem } from '../../../hooks/useListItem';
import Dialog from '../../atoms/Dialog';
import StatusTag from '../../atoms/StatusTag';
import SelectField from '../../atoms/SelectField';
import TextField from '../../atoms/TextField';
import { order as orderApi } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import { camelize } from '../../../utils/camelize';
import { useNotify } from '../../../hooks/notificationHook';
var OrderStatus = function (_a) {
    var order = _a.order, onOrderChanged = _a.onOrderChanged;
    var t = useTranslation().t;
    var theme = useTheme();
    var allStatusItems = useOrderListItem().statusItems;
    var _b = React.useState(false), dialogOpen = _b[0], setDialogOpen = _b[1];
    var _c = React.useState(order.status), nextStatus = _c[0], setNextStatus = _c[1];
    var _d = React.useState(order.canceledReason), nextCanceledReason = _d[0], setNextCanceledReason = _d[1];
    var updateStatusApi = useRequest(orderApi.updateStatus);
    var notify = useNotify();
    var changeableStatusItems = React.useMemo(function () {
        var status = order.status, _a = order.offerLists, offerLists = _a === void 0 ? [] : _a;
        var allowedStatuses = getAllowedStatus(status);
        var items = allStatusItems.filter(function (status) {
            return allowedStatuses.includes(status.value);
        });
        if (offerLists.every(function (_a) {
            var fixed = _a.fixed;
            return fixed;
        })) {
            return items.filter(function (status) { return status.value !== 'reserved'; });
        }
        return items.filter(function (status) { return status.value !== 'confirmed'; });
    }, [order, allStatusItems]);
    var updateOrderStatus = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var params, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {
                        id: order.id,
                        order: {
                            status: nextStatus,
                        },
                    };
                    if (nextStatus === 'canceled')
                        params.order.canceled_reason = nextCanceledReason;
                    return [4 /*yield*/, updateStatusApi(params)];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    onOrderChanged(response);
                    setDialogOpen(false);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [
        nextStatus,
        nextCanceledReason,
        updateStatusApi,
        order.id,
        onOrderChanged,
        t,
        notify,
    ]);
    return (React.createElement(Box, { display: "block" },
        React.createElement(Box, { display: "flex" },
            React.createElement(StatusTag, { className: order.status }, t("params.order.statuses.".concat(camelize(order.status)))),
            React.createElement(Button, { size: "small", style: { marginLeft: 10 }, onClick: function () { return setDialogOpen(true); }, disabled: order.status === 'canceled' }, t('pages.orderDetail.changeStatus')),
            React.createElement(Dialog, { title: t('pages.orderDetail.changeStatus'), open: dialogOpen, onClose: function () { return setDialogOpen(false); }, style: { zIndex: theme.zIndex.modal }, actions: React.createElement(Button, { variant: "contained", style: { marginLeft: 10 }, onClick: updateOrderStatus, disabled: order.status === nextStatus }, t('buttons.update')) },
                React.createElement(Grid, { container: true, spacing: 2, display: "block", minWidth: 500, mt: 1 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(SelectField, { fullWidth: true, required: true, label: t('params.order.status'), value: nextStatus, onChange: function (event) {
                                return setNextStatus(event.target.value);
                            }, items: changeableStatusItems })),
                    nextStatus === 'canceled' && (React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { multiline: true, fullWidth: true, required: true, rows: 3, label: t('params.order.canceledReason'), value: nextCanceledReason, error: nextCanceledReason.trim().length === 0, onChange: function (event) {
                                return setNextCanceledReason(event.target.value);
                            } })))))),
        order.status === 'canceled' && (React.createElement(React.Fragment, null,
            React.createElement(Box, { mt: 1 },
                t('params.order.canceledReason'),
                ":"),
            React.createElement(Box, { mt: 1, paddingLeft: 2 }, order.canceledReason)))));
};
export default OrderStatus;
var getAllowedStatus = function (currentStatus) {
    switch (currentStatus) {
        case 'canceled':
            return ['canceled'];
        case 'under_review':
            return ['under_review', 'reserved', 'confirmed', 'canceled'];
        case 'confirmed':
            return ['confirmed', 'canceled'];
        case 'reserved':
            return ['reserved', 'confirmed', 'canceled'];
        default:
            throw Error('unknown status');
    }
};
